/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var UsageDarkGray = function UsageDarkGray(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Usage icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['usage--dark-gray', 'usage--dark-gray-2', 'usage--dark-gray-3', 'usage--dark-gray-4', 'usage--dark-gray-5', 'usage--dark-gray-6', 'usage--dark-gray-7', 'usage--dark-gray-8', 'usage--dark-gray-9', 'usage--dark-gray-10', 'usage--dark-gray-11', 'usage--dark-gray-12', 'usage--dark-gray-13', 'usage--dark-gray-14', 'usage--dark-gray-15', 'usage--dark-gray-16'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 200"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-4'],
    x1: "66.98",
    x2: "66.98",
    y1: "206.78",
    y2: "29.82",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#161616",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-5'],
    x1: "50.11",
    x2: "83.93",
    y1: "456.55",
    y2: "397.97",
    gradientTransform: "matrix(1 0 0 -1 0 568.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-6'],
    x1: "67.19",
    x2: "134",
    y1: "405.34",
    y2: "405.34",
    gradientTransform: "matrix(1 0 0 -1 0 568.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-2'],
    x2: "67.24",
    y1: "405.34",
    y2: "405.34",
    gradientTransform: "matrix(1 0 0 -1 0 568.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-1'],
    x1: "50.95",
    x2: "15.99",
    y1: "157.15",
    y2: "136.96",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d6d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".1",
    stopColor: "#191919",
    stopOpacity: ".84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".58",
    stopColor: "#232323",
    stopOpacity: ".22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-7'],
    x1: "66.12",
    x2: "31.15",
    y1: "149.36",
    y2: "129.17",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-8'],
    x1: "81.96",
    x2: "47",
    y1: "140.86",
    y2: "120.67",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-9'],
    x1: "96.79",
    x2: "61.83",
    y1: "133.63",
    y2: "113.45",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-10'],
    x1: "76.37",
    x2: "76.37",
    y1: "141.26",
    y2: "78.93",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-3'],
    x1: "80.57",
    x2: "80.57",
    y1: "141.27",
    y2: "78.93",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-11'],
    x1: "60.52",
    x2: "60.52",
    y1: "149.76",
    y2: "93.44",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-12'],
    x1: "64.72",
    x2: "64.72",
    y1: "149.77",
    y2: "93.43",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-3'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-13'],
    x1: "91.2",
    x2: "91.2",
    y1: "134.04",
    y2: "67.05",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-14'],
    x1: "95.4",
    x2: "95.4",
    y1: "134.04",
    y2: "67.04",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-3'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-15'],
    x1: "45.36",
    x2: "45.36",
    y1: "157.55",
    y2: "110.78",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-gray-16'],
    x1: "49.56",
    x2: "49.56",
    y1: "157.55",
    y2: "110.79",
    xlinkHref: "#".concat(gradientIds['usage--dark-gray-3'])
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-4'], ")"),
    d: "M66.76 102.24L134 141.17V0H0v141.17z",
    opacity: ".4",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-5'], ")"),
    d: "M0 141.07l66.77-38.93L134 141.07 67.24 180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-6'], ")"),
    d: "M134 141.07v4.9L67.19 184.9V180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-2'], ")"),
    d: "M67.24 180v4.9L0 146v-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    fillOpacity: ".3",
    d: "M67.19 184.9l-54.2-31.4L0 161.07 67.19 200l66.77-38.93-12.99-7.52-53.78 31.35z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-1'], ")"),
    d: "M16.01 139.4l4.21-2.42 31.44 18.15-4.21 2.42-31.44-18.15z",
    opacity: ".5",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-7'], ")"),
    d: "M31.18 131.61l4.2-2.42 31.44 18.15-4.2 2.42-31.44-18.15z",
    opacity: ".5",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-8'], ")"),
    d: "M47.02 123.11l4.21-2.42 31.44 18.15-4.21 2.42-31.44-18.15z",
    opacity: ".5",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-9'], ")"),
    d: "M61.86 115.89l4.2-2.42 31.44 18.15-4.2 2.42-31.44-18.15z",
    opacity: ".5",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-10'], ")"),
    d: "M74.27 78.93l4.19 2.43v59.9l-4.19-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-3'], ")"),
    d: "M78.47 81.36l4.2-2.43v59.91l-4.2 2.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M74.27 78.93l4.2-2.42 4.19 2.42-4.19 2.43-4.2-2.43z",
    opacity: ".3",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-11'], ")"),
    d: "M58.43 93.44l4.19 2.42v53.9l-4.19-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-12'], ")"),
    d: "M62.62 95.86l4.2-2.43v53.91l-4.2 2.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M58.43 93.44l4.2-2.43 4.19 2.43-4.19 2.42-4.2-2.42z",
    opacity: ".3",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-13'], ")"),
    d: "M89.1 67.05l4.2 2.43V134l-4.2-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-14'], ")"),
    d: "M93.3 69.47L97.5 67v64.58L93.3 134z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M89.1 67.05l4.2-2.42 4.19 2.42-4.19 2.43-4.2-2.43z",
    opacity: ".3",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-15'], ")"),
    d: "M43.26 110.78l4.19 2.43v44.34l-4.19-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-gray-16'], ")"),
    d: "M47.46 113.21l4.2-2.42v44.34l-4.2 2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M43.26 110.78l4.2-2.42 4.19 2.42-4.19 2.43-4.2-2.43z",
    opacity: ".3",
    style: {
      isolation: 'isolate'
    }
  }));
};
UsageDarkGray.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var UsageDarkGray$1 = UsageDarkGray;

export { UsageDarkGray$1 as default };
